import { signalSdk } from '@/utils/getSDK'
const SWITCHMODAL = 'SWITCHMODAL'
const CHANGETIMETOSEND = 'CHANGETIMETOSEND'
const MODIFYSILENCELIST = 'MODIFYSILENCELIST'
const boolMutation = (arr) => {
  let mArr = {}
  let aArr = {}
  arr.forEach((s) => {
    mArr[`${s}Mutation`] = (state, bool) => {
      state[s] = bool
    }
    let firstUpperCase = s[0].toUpperCase() + s.slice(1)
    aArr[`switch${firstUpperCase}`] = ({ commit }, bool) => {
      console.log(`【${s}Mutation】`, bool)
      commit(`${s}Mutation`, bool)
    }
  })
  return {
    mArr,
    aArr
  }
}
const { mArr, aArr } = boolMutation(['allowChatWithMessage', 'showUserNum', 'showSilentList'])

export default {
  state: {
    modal: false,
    allowChatWithMessage: true, // 是否允许学生文字聊天
    showUserNum: true,
    timeToSendMessage: 1,
    silentUserList: [],
    showSilentList: false
  },
  getters: {
    silentUserIDList: (state) => {
      return state.silentUserList.map((user) => user.userid)
    }
  },
  mutations: {
    ...mArr,
    SWITCHMODAL (state, bool) {
      state.modal = bool
    },
    CHANGETIMETOSEND (state, payload) {
      state.timeToSendMessage = payload
    },
    MODIFYSILENCELIST (state, { type = 'add', payload }) {
      console.log(payload)
      if (type === 'add') {
        if (Object.prototype.toString.call(payload) === '[object Array]') {
          state.silentUserList = state.silentUserList.concat(payload)
        } else {
          state.silentUserList.push(payload)
        }
      } else if (type === 'delete') {
        state.silentUserList = state.silentUserList.filter((user) => user.userid !== payload )
      }
    },

  },
  actions: {
    ...aArr,
    switchModalStatus ({ commit }, bool) {
      commit(SWITCHMODAL, bool)
    },
    changeTimeToSendMessage ({ commit }, payload) {
      commit(CHANGETIMETOSEND, payload)
    },
    getSilentUserList ({commit}) {
      signalSdk.getSilentUserList().then((list) => {
        if (!list) {
          return
        }
        commit(MODIFYSILENCELIST, { payload: list })
      })
    },
    modifySilentUserList ({commit}, payload) {
      commit(MODIFYSILENCELIST, { payload: payload })
    },
    deleteUserFromSilenceList ({commit}, id) {
      commit(MODIFYSILENCELIST, { type: 'delete', payload: id })
    }
  }
}
